<google-map height="500px"
            width="100%"
            [center]="center"
            [zoom]="14"
            [options]="mapOptions">
</google-map>